import React, { useState, useEffect } from 'react'
import { Calendar } from 'lucide-react'
import HeatMap from '../components/HeatMap'
import api from '../services/api'

const HeatMapPage = () => {
  const [range, setRange] = useState('30d')
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const ranges = ['7d', '30d', '90d', '1y']

  const fetchData = async (period) => {
    try {
      setLoading(true)
      const res = await api.get(`/analytics/heatmap?timeRange=${period}`)
      if (res.data?.success) setData(res.data.data)
    } catch (err) {
      console.error('Heatmap fetch error:', err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => { fetchData(range) }, [])

  const handleRangeChange = (r) => {
    setRange(r)
    fetchData(r)
  }

  return (
    <div className="space-y-8">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Heat Map</h1>
          <p className="text-gray-500 mt-1">Geographic counterfeit detection patterns</p>
        </div>
        <div className="flex items-center space-x-2 mt-4 sm:mt-0">
          {ranges.map(r => (
            <button key={r} onClick={() => handleRangeChange(r)}
              className={`px-4 py-2 rounded-xl text-sm font-medium transition-all ${
                range === r ? 'bg-[#1E4D40] text-white' : 'bg-white text-gray-600 hover:bg-gray-100 border border-gray-200'
              }`}>{r}</button>
          ))}
        </div>
      </div>
      <div className="bg-white rounded-3xl shadow-sm overflow-hidden" style={{ height: '600px' }}>
        <HeatMap data={data} loading={loading} onTimeRangeChange={handleRangeChange} />
      </div>
      <div className="flex items-center space-x-2 text-sm text-gray-500">
        <Calendar className="h-4 w-4" />
        <span>Showing data for the last {range}</span>
      </div>
    </div>
  )
}

export default HeatMapPage
